export default __webpack_public_path__ + "static/media/AppShieldLogo.9934208c.svg";